import React, { useState, useEffect } from 'react';
import { Box, Checkbox, FormControlLabel, TextField, Typography } from '@mui/material';

const MAX_CHARS = 500;

export const CommentQuestion = ({ question, answer, onAnswerChange }) => {
  console.log(question)
  const [isNA, setIsNA] = useState(answer === 'N/A');

  useEffect(() => {
    setIsNA(answer === 'N/A');
  }, [question.id]);

  const textValue = isNA ? '' : (answer || '');

  const handleTextChange = (e) => {
    const value = e.target.value.slice(0, MAX_CHARS);
    onAnswerChange(value);
  };

  const handleNAChange = (e) => {
    const checked = e.target.checked;
    setIsNA(checked);
    onAnswerChange(checked ? 'N/A' : '');
  };

  return (
    <Box sx={{ width: '100%' }}>
      <TextField
        multiline
        fullWidth
        minRows={1}
        maxRows={2}
        value={textValue}
        onChange={handleTextChange}
        disabled={isNA}
        placeholder="Share your thoughts here..."
        inputProps={{ maxLength: MAX_CHARS }}
        sx={{
          '& .MuiOutlinedInput-root': {
            borderRadius: 2,
            '& fieldset': { borderColor: '#ddd' },
            '&:hover fieldset': { borderColor: '#2aa1d3' },
            '&.Mui-focused fieldset': { borderColor: '#2aa1d3' },
          },
        }}
      />
      <Typography
        variant="caption"
        align="right"
        display="block"
        sx={{ color: '#999', mt: 0.5 }}
      >
        {textValue.length}/{MAX_CHARS}
      </Typography>
      {!question.required && (
        <FormControlLabel
          control={
            <Checkbox
              checked={isNA}
              onChange={handleNAChange}
              sx={{
                color: '#ddd',
                '&.Mui-checked': { color: '#2aa1d3' },
              }}
            />
          }
          label="N/A"
          sx={{ mt: 0.5 }}
        />
      )}
    </Box>
  );
};